import React from "react";
import type { LivePreviewFrameProps } from "./LivePreviewFrame.types";
import { Empty, Frame, Heading, Root } from "./LivePreviewFrame.styles";

/** A heading over a framed live page; without a src the same box shows the empty text, so nothing jumps. */
export const LivePreviewFrame: React.FC<LivePreviewFrameProps> = ({ heading, title, src, emptyText, height = "24rem", className }) => (
  <Root className={className}>
    <Heading>{heading}</Heading>
    {src ? <Frame title={title} src={src} $height={height} /> : <Empty $height={height} role="status">{emptyText}</Empty>}
  </Root>
);

export default LivePreviewFrame;
